import { GET_USERINFO } from './mutation-types'

export default {
  setUserInfo({
		commit,
		state
	}) {
		let res = localStorage.getItem("user");
		commit(GET_USERINFO, res)
	}
}



// WEBPACK FOOTER //
// ./src/store/action.js